import {
    DELETE_USER_PRODUCT_MEMBERSHIP,
    DELETE_USER_PRODUCT_MEMBERSHIP_FAILURE,
    DELETE_USER_PRODUCT_MEMBERSHIP_SUCCESS,
} from 'store/actions/types';

export const deleteUserProductMembership = (payload) => {
    return {
        type: DELETE_USER_PRODUCT_MEMBERSHIP,
        payload,
    };
};

export const deleteUserProductMembershipFailure = (error) => {
    return {
        type: DELETE_USER_PRODUCT_MEMBERSHIP_FAILURE,
        error,
    };
};

export const deleteUserProductMembershipSuccess = (id) => {
    return {
        type: DELETE_USER_PRODUCT_MEMBERSHIP_SUCCESS,
        payload: [
            id,
        ],
    };
};


// WEBPACK FOOTER //
// ./src/store/actions/users/product-memberships/deleteUserProductMembership.js